var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimateBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180249",
    "data-name": "Group 180249",
    transform: "translate(-485.979 -67.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_679",
    "data-name": "Ellipse 679",
    transform: "translate(485.979 67.688)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21182",
    "data-name": "Path 21182",
    d: "M276.357,131.6l-.68,7.811,5.434-1.7L276.357,149.6l.679-7.811-5.434,1.7Z",
    transform: "translate(221.625 -60.912)",
    fill: "#c3c3c3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimateBannerIcon);
export default __webpack_public_path__ + "static/media/animateBannerIcon.b6a973a7e1aa85ae17a09e8d805041f7.svg";
export { ForwardRef as ReactComponent };